// Read persisted synthetic daily OHLC; never infer high/low from mean returns.
export function buildBreadthTrend(rows) {
    let closes = []
    const result = new Map()
    rows.slice().sort((a, b) => a.date.localeCompare(b.date)).forEach(row => {
        const keys = ['p_open', 'p_close', 'p_low', 'p_high']
        const candle = keys.map(key => row[key] == null ? NaN : Number(row[key]))
        const [open, close, low, high] = candle
        if (candle.some(value => !Number.isFinite(value) || value <= 0) || low > Math.min(open, close) || high < Math.max(open, close)) {
            closes = []
            result.set(row.date, { candle: null, ma: [null, null, null] })
            return
        }
        closes.push(close)
        result.set(row.date, {
            candle,
            ma: [5, 10, 20].map(period => closes.length < period ? null : closes.slice(-period).reduce((a, b) => a + b, 0) / period)
        })
    })
    return result
}
